<script lang="ts">import {} from 'svelte';
import Context from './components/Context/Context.svelte';
let { children, ...rest } = $props();
let canvas = $state();
let dom = $state();
</script>

<div bind:this={dom}>
  <canvas bind:this={canvas}>
    {#if canvas && dom}
      <Context
        {dom}
        {canvas}
        {...rest}
      >
        {@render children?.()}
      </Context>
    {/if}
  </canvas>
</div>

<style>
  div {
    position: relative;
    width: 100%;
    height: 100%;
  }

  canvas {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
  }
</style>
